export class Conflict extends Error
{
    type = "ConflictException";
}